import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import Provider from "react-redux/es/components/Provider";
import store from "./store";
import {BrowserRouter} from "react-router-dom";

const getBasename = () => {
    return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};

ReactDOM.render(
    <BrowserRouter basename={getBasename()}>
        <Provider store={store}>
            <App/>
        </Provider>
    </BrowserRouter>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js